import { useEffect, useState } from 'react';
import styles from './MarketplaceGroupsModal.module.css';
import { MarketplaceGroup } from '../../../Models/MarketplaceGroupModel';
import { GetSelectedMarketplaceGroups, SelectMarketplaceGroups } from '../../../Api/Services/Alternative';

export default function MarketplaceGroupsModal({ id, handleClose }: { id: number, handleClose(): void }) {
    const [marketplaceGroups, setMarketplaceGroups] = useState<MarketplaceGroup[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        GetSelectedMarketplaceGroups(id).then((data) => {
            setMarketplaceGroups(data);
        });
    }, [id]);

    const handleCheckboxChange = (marketplaceGroupId: number, selected: boolean) => {
        setMarketplaceGroups(prev => 
            prev.map(group => 
                group.marketplaceGroupId === marketplaceGroupId 
                    ? { ...group, selected } 
                    : group
            )
        );
    };

    const saveMarketplaceGroups = () => {
        setLoading(true);
        SelectMarketplaceGroups(id, marketplaceGroups).then((response) => {
            setLoading(false);
            if (response.success) {
                handleClose();
            } else {
                console.error('Error saving marketplace groups:', response.message);
                // You could add error handling/notification here
            }
        });
    };

    return (
        <div className={styles.backdrop}>
            <div className={styles.modal}>
                <h3>Marketplace Groups</h3>
                <div className={styles.groupsList}>
                    {marketplaceGroups.map((group) => (
                        <div key={group.marketplaceGroupId} className={styles.groupItem}>
                            <label className={styles.checkboxLabel}>
                                <input
                                    type="checkbox"
                                    checked={group.selected}
                                    onChange={(e) => handleCheckboxChange(group.marketplaceGroupId, e.target.checked)}
                                    disabled={loading}
                                />
                                <span className={styles.groupName}>{group.name}</span>
                            </label>
                        </div>
                    ))}
                </div>
                <div className={styles.flex}>
                    <button 
                        type="button" 
                        className="button" 
                        onClick={saveMarketplaceGroups}
                        disabled={loading}
                    >
                        {loading ? 'Saving...' : 'Save'}
                    </button>
                    <button 
                        type="button" 
                        className="button button_black" 
                        onClick={handleClose}
                        disabled={loading}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}
